import { Injectable } from '@angular/core';

export type Toast = {
  id: number;
  status: 'success' | 'error' | 'warning' | 'info';
  message: string;
  progressPercentage: number;
  lastUpdated: number;
};

type ToastStatus = 'success' | 'error' | 'warning' | 'info';

const TOAST_BASE_TIME = 10 * 1000; // 10 seconds

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  currentToasts: Toast[] = [];

  constructor() {}

  addToast(status: ToastStatus, message: string) {
    const newToast: Toast = {
      id: Math.random(),
      status: status,
      message: message,
      progressPercentage: 100,
      lastUpdated: Date.now(),
    };
    console.log('addToast: ', newToast);

    this.currentToasts.push(newToast);
  }

  decrementToastProgress(toast: Toast) {
    // calcuate the percentage of time elapsed based on the time since last update
    const amount = ((Date.now() - toast.lastUpdated) / TOAST_BASE_TIME) * 100;
    toast.progressPercentage = Math.max(0, toast.progressPercentage - amount);
    if (toast.progressPercentage <= 0) {
      this.removeToast(toast);
    } else {
      toast.lastUpdated = Date.now();
    }
  }

  updateLastUpdated(toast: Toast) {
    toast.lastUpdated = Date.now();
  }

  removeToast(toast: Toast) {
    console.log('removeToast: ', toast);
    this.currentToasts = this.currentToasts.filter((t) => t.id !== toast.id);
  }
}
